<div *ngIf="!terminalMode || !screenWidth || screenWidth >= Constants.SMALL_MENU_SIZE || orderDisplay"
     class="image-container" #imageContainer>
    <div class="menu-item-image-backdrop"
         [class.low-inventory]="!orderDisplay && terminalMode && !insufficientInventory() && warnInventory()"
         style="background: linear-gradient(180deg, {{color}} 25.52%, rgba(255, 250, 235, 0) 94.79%);">
        &nbsp;
    </div>
    <ion-badge *ngIf="orderType === availabilities.TOGO"
               color="warning"
               class="togo-indicator">
        <ion-icon name="car-sport-outline"></ion-icon>
    </ion-badge>

    <ng-container *ngIf="terminalMode && !orderDisplay">
        <ion-badge *ngIf="terminalMode && insufficientInventory()"
                   color="danger"
                   class="low-inventory-indicator"
                   (click)="adjustInventory($event, exactInventory)">
            <ion-icon [name]="(!!exactInventory && exactInventory.active) ? 'alert-circle-outline' : 'ban-outline'"></ion-icon>
        </ion-badge>

        <div *ngIf="isKegInventory() && !!exactInventory && !insufficientInventory()"
             class="low-inventory-indicator" (click)="kickKeg($event)">
            <bb-keg-status [menuItemInventory]="exactInventory"
                           [radius]="kegRadius"
                           backgroundColor="#000000"
                           (click)="adjustInventory($event, exactInventory)"></bb-keg-status>
        </div>

        <ion-badge *ngIf="showInventory && !isKegInventory() && !insufficientInventory() && !!exactInventory"
                   color="dark"
                   class="low-inventory-indicator"
                   (click)="adjustInventory($event, exactInventory)">
            <ion-text>{{ exactInventory.currentCount }}</ion-text>
        </ion-badge>
    </ng-container>

    <img *ngIf="((!!menuItem && !!menuItem.imageAddress) || !!imageAddressOverride) && !hideImage"
         draggable="false"
         [src]="imageSrc"
         class="menu-item-image" alt=""
         (load)="imageLoaded.emit()">
    <div [hidden]="((!!menuItem && !!menuItem.imageAddress) || !!imageAddressOverride) && !hideImage" class="missing-image">
        <div class="item-name" style="color: {{contrastColor}};">
            <span>{{ !!menuItem ? menuItem.name : nameOverride }}</span>
            <div *ngIf="!!menuItem && !!menuItem.flavorText" class="flavor-text">
                {{ menuItem.flavorText }}
            </div>
        </div>
    </div>
    <div *ngIf="!!menuItem && !!menuItem.labels && menuItem.labels.length > 0" class="image-labels">
        <div *ngFor="let label of menuItem.labels" class="label-container">
            <bb-menu-label *ngIf="label.display" [menuLabel]="label.label"></bb-menu-label>
        </div>
    </div>
</div>
<div *ngIf="!orderDisplay && screenWidth < Constants.SMALL_MENU_SIZE"
     class="small-terminal"
     style="background: {{color}}; color: {{contrastColor}};">
    {{ !!menuItem ? menuItem.name : nameOverride }}
</div>
